import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Leftmenu from "../../components/Leftmenu";
import Rightmenu from "../../components/Rightmenu";
import { Link, useOutletContext, useNavigate } from "react-router-dom";
import moment from "moment";

function AdminDashboard() {
  const { user, token } = useOutletContext();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && user.role !== "admin") {
      navigate("/");
      return;
    }

    fetchStats();
  }, [user]);

  const fetchStats = () => {
    setLoading(true);
    fetch("/api/admin/dashboard-stats", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((resData) => {
        setLoading(false);
        if (resData.data) {
          setStats(resData.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching stats:", err);
        setLoading(false);
      });
  };

  const handleUpdateUserStatus = (userId, newStatus) => {
    fetch("/api/admin/update-user-status", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user_id: userId, status: newStatus }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.message) {
          fetchStats();
        } else if (data.error) {
          alert(data.error);
        }
      })
      .catch((err) => console.error(err));
  };

  const handleUpdatePostStatus = (postId, newStatus) => {
    fetch("/api/admin/update-post-status", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ post_id: postId, status: newStatus }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.message) {
          fetchStats();
        } else if (data.error) {
          alert(data.error);
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <div>
      <Header />
      <Leftmenu />
      <div className="main-content bg-lightblue theme-dark-bg admin-main-page" style={{ minHeight: "100vh" }}>
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left w-100" style={{ maxWidth: "100%", margin: 0, paddingRight: 0 }}>
            <div className="admin-wrap-full w-100" style={{ maxWidth: "100%", margin: 0 }}>
              {/* Header Card */}
              <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4 rounded-xxl overflow-hidden">
                <div className="card-body p-4 w-100 bg-current border-0 d-flex align-items-center justify-content-between rounded-3">
                  <div className="d-flex align-items-center">
                    <i className="feather-shield font-lg text-white me-3"></i>
                    <div>
                      <h4 className="font-xs text-white fw-600 mb-0">Admin Area - Dashboard</h4>
                      <span className="font-xssss text-white opacity-75">Overview & Management Control Center</span>
                    </div>
                  </div>
                  <span className="badge bg-white text-danger font-xssss fw-700 px-3 py-2 rounded-pill">
                    ADMIN
                  </span>
                </div>
              </div>

              {loading ? (
                <div className="card w-100 text-center border-0 p-5 mb-4 shadow-xss rounded-xxl">
                  <div className="spinner-border text-danger mx-auto" role="status"></div>
                  <p className="mt-3 text-grey-600 font-xsss mb-0">Loading dashboard metrics...</p>
                </div>
              ) : (
                <>
                  {/* Stats Cards - 5 Cards Grid */}
                  <div className="row g-3 mb-4">
                    <div className="col-xl col-lg-4 col-md-6">
                      <div className="card shadow-xss border-0 p-3 rounded-xxl bg-white h-100">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="text-grey-500 font-xssss fw-600 text-uppercase">Total Users</span>
                          <i className="feather-users text-primary font-md"></i>
                        </div>
                        <h2 className="fw-700 text-grey-900 font-lg mb-1">{stats?.total_users || 0}</h2>
                        <span className="font-xsssss text-grey-500">{stats?.approved_accounts || 0} Approved</span>
                      </div>
                    </div>

                    <div className="col-xl col-lg-4 col-md-6">
                      <div className="card shadow-xss border-0 p-3 rounded-xxl bg-white h-100 border-start border-warning border-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="text-grey-500 font-xssss fw-600 text-uppercase">Pending Approval</span>
                          <i className="feather-user-check text-warning font-md"></i>
                        </div>
                        <h2 className="fw-700 text-warning font-lg mb-1">{stats?.pending_accounts || 0}</h2>
                        <Link to="/admin/pending-accounts" className="font-xsssss fw-600 text-warning text-decoration-none">
                          Complete Profile &rarr;
                        </Link>
                      </div>
                    </div>

                    <div className="col-xl col-lg-4 col-md-6">
                      <div className="card shadow-xss border-0 p-3 rounded-xxl bg-white h-100 border-start border-secondary border-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="text-grey-500 font-xssss fw-600 text-uppercase">Incomplete Accounts</span>
                          <i className="feather-alert-triangle text-secondary font-md"></i>
                        </div>
                        <h2 className="fw-700 text-secondary font-lg mb-1">{stats?.incomplete_accounts || 0}</h2>
                        <Link to="/admin/pending-accounts?status=incomplete" className="font-xsssss fw-600 text-secondary text-decoration-none">
                          In Progress &rarr;
                        </Link>
                      </div>
                    </div>

                    <div className="col-xl col-lg-6 col-md-6">
                      <div className="card shadow-xss border-0 p-3 rounded-xxl bg-white h-100 border-start border-danger border-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="text-grey-500 font-xssss fw-600 text-uppercase">Pending Posts</span>
                          <i className="feather-clock text-danger font-md"></i>
                        </div>
                        <h2 className="fw-700 text-danger font-lg mb-1">{stats?.pending_posts || 0}</h2>
                        <Link to="/admin/pending-posts" className="font-xsssss fw-600 text-danger text-decoration-none">
                          Review Posts &rarr;
                        </Link>
                      </div>
                    </div>

                    <div className="col-xl col-lg-6 col-md-6">
                      <div className="card shadow-xss border-0 p-3 rounded-xxl bg-white h-100">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="text-grey-500 font-xssss fw-600 text-uppercase">Total Posts</span>
                          <i className="feather-file-text text-success font-md"></i>
                        </div>
                        <h2 className="fw-700 text-grey-900 font-lg mb-1">{stats?.total_posts || 0}</h2>
                        <span className="font-xsssss text-grey-500">{stats?.banned_posts || 0} Banned</span>
                      </div>
                    </div>
                  </div>

                  {/* Navigation Hub */}
                  <div className="row mb-4">
                    <div className="col-12">
                      <div className="card shadow-xss border-0 p-3 rounded-xxl bg-white">
                        <div className="d-flex flex-wrap gap-2">
                          <Link to="/admin/dashboard" className="btn btn-sm bg-current text-white font-xssss fw-600 px-3 py-2 rounded-xl">
                            <i className="feather-grid me-1"></i> Dashboard
                          </Link>
                          <Link to="/admin/pending-accounts" className="btn btn-sm bg-light text-grey-800 font-xssss fw-600 px-3 py-2 rounded-xl">
                            <i className="feather-user-check me-1 text-warning"></i> Pending Approval ({stats?.pending_accounts || 0})
                          </Link>
                          <Link to="/admin/pending-accounts?status=incomplete" className="btn btn-sm bg-light text-grey-800 font-xssss fw-600 px-3 py-2 rounded-xl">
                            <i className="feather-alert-triangle me-1 text-secondary"></i> Incomplete Accounts ({stats?.incomplete_accounts || 0})
                          </Link>
                          <Link to="/admin/pending-posts" className="btn btn-sm bg-light text-grey-800 font-xssss fw-600 px-3 py-2 rounded-xl">
                            <i className="feather-check-square me-1 text-danger"></i> Pending Posts ({stats?.pending_posts || 0})
                          </Link>
                          <Link to="/admin/activity-logs" className="btn btn-sm bg-light text-grey-800 font-xssss fw-600 px-3 py-2 rounded-xl">
                            <i className="feather-activity me-1 text-primary"></i> Activity Logs
                          </Link>
                          <Link to="/admin/admin-manager" className="btn btn-sm bg-light text-grey-800 font-xssss fw-600 px-3 py-2 rounded-xl">
                            <i className="feather-shield me-1 text-success"></i> Admin Manager
                          </Link>
                          <Link to="/admin/committee-members" className="btn btn-sm bg-light text-grey-800 font-xssss fw-600 px-3 py-2 rounded-xl">
                            <i className="feather-award me-1 text-danger"></i> Committee Members
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Pending Accounts & Incomplete Accounts Row */}
                  <div className="row">
                    {/* Pending Accounts (Complete Profile) */}
                    <div className="col-lg-6 mb-4">
                      <div className="card shadow-xss border-0 p-4 rounded-xxl bg-white h-100">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div>
                            <h4 className="fw-700 font-xss text-grey-900 mb-0 d-flex align-items-center">
                              <i className="feather-user-check text-warning me-2"></i> Pending Accounts
                            </h4>
                            <span className="font-xsssss text-grey-500">Profiles complete, awaiting admin approval</span>
                          </div>
                          <Link to="/admin/pending-accounts" className="font-xssss fw-600 text-danger text-decoration-none">
                            View All &rarr;
                          </Link>
                        </div>
                        {stats?.recent_pending_accounts?.length > 0 ? (
                          <div className="table-responsive">
                            <table className="table table-borderless align-middle mb-0 font-xssss">
                              <tbody>
                                {stats.recent_pending_accounts.map((acc) => (
                                  <tr key={acc.id} className="border-bottom">
                                    <td className="py-2 ps-0">
                                      <h6 className="font-xsss fw-700 text-grey-900 mb-0">{acc.name}</h6>
                                      <span className="font-xsssss text-grey-500">{acc.email}</span>
                                    </td>
                                    <td>
                                      <span className="badge bg-light text-dark font-xsssss text-uppercase px-2 py-1 rounded-pill border">
                                        {acc.role}
                                      </span>
                                      {acc.profile_status === "complete" && (
                                        <span className="badge bg-success text-white font-xsssss px-2 py-1 rounded-pill d-block mt-1" style={{ width: "fit-content" }}>
                                          ✓ Complete
                                        </span>
                                      )}
                                    </td>
                                    <td className="text-end pe-0">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-success font-xsssss fw-600 px-3 py-1 rounded-2"
                                        onClick={() => handleUpdateUserStatus(acc.id, "approved")}
                                      >
                                        Approve
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <p className="text-grey-500 font-xssss my-3">No pending completed account approvals.</p>
                        )}
                      </div>
                    </div>

                    {/* Incomplete Accounts Preview */}
                    <div className="col-lg-6 mb-4">
                      <div className="card shadow-xss border-0 p-4 rounded-xxl bg-white h-100">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div>
                            <h4 className="fw-700 font-xss text-grey-900 mb-0 d-flex align-items-center">
                              <i className="feather-alert-triangle text-secondary me-2"></i> Incomplete Accounts
                            </h4>
                            <span className="font-xsssss text-grey-500">Users who haven't completed registration steps</span>
                          </div>
                          <Link to="/admin/pending-accounts?status=incomplete" className="font-xssss fw-600 text-danger text-decoration-none">
                            View All &rarr;
                          </Link>
                        </div>
                        {stats?.recent_incomplete_accounts?.length > 0 ? (
                          <div className="table-responsive">
                            <table className="table table-borderless align-middle mb-0 font-xssss">
                              <tbody>
                                {stats.recent_incomplete_accounts.map((acc) => (
                                  <tr key={acc.id} className="border-bottom">
                                    <td className="py-2 ps-0">
                                      <h6 className="font-xsss fw-700 text-grey-900 mb-0">{acc.name}</h6>
                                      <span className="font-xsssss text-grey-500">{acc.email}</span>
                                    </td>
                                    <td>
                                      <span className="badge bg-light text-dark font-xsssss text-uppercase px-2 py-1 rounded-pill border">
                                        {acc.role || "student"}
                                      </span>
                                      <span className="badge bg-secondary text-white font-xsssss text-uppercase px-2 py-1 rounded-pill d-block mt-1" style={{ width: "fit-content" }}>
                                        {acc.profile_status || "incomplete"}
                                      </span>
                                    </td>
                                    <td className="text-end pe-0 text-grey-500 font-xsssss">
                                      {moment(acc.created_at).fromNow()}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <p className="text-grey-500 font-xssss my-3">No incomplete accounts registered.</p>
                        )}
                      </div>
                    </div>

                    {/* Pending Posts Column */}
                    <div className="col-lg-6 mb-4">
                      <div className="card shadow-xss border-0 p-4 rounded-xxl bg-white h-100">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h4 className="fw-700 font-xss text-grey-900 mb-0 d-flex align-items-center">
                            <i className="feather-clock text-danger me-2"></i> Pending Posts
                          </h4>
                          <Link to="/admin/pending-posts" className="font-xssss fw-600 text-danger text-decoration-none">
                            View All &rarr;
                          </Link>
                        </div>
                        {stats?.recent_pending_posts?.length > 0 ? (
                          <div>
                            {stats.recent_pending_posts.map((p) => (
                              <div key={p.id} className="p-3 mb-2 border rounded-3 bg-greylight">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <span className="font-xssss fw-700 text-grey-900">{p.user?.name || "User"}</span>
                                  <span className="font-xsssss text-grey-500">{moment(p.created_at).fromNow()}</span>
                                </div>
                                <p className="font-xssss text-grey-700 mb-2">{p.content || "[Media Post]"}</p>
                                <div className="d-flex gap-2">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-success font-xsssss fw-600 px-3 py-1 rounded-2"
                                    onClick={() => handleUpdatePostStatus(p.id, "approved")}
                                  >
                                    Approve
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger font-xsssss fw-600 px-3 py-1 rounded-2"
                                    onClick={() => handleUpdatePostStatus(p.id, "banned")}
                                  >
                                    Ban
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="text-grey-500 font-xssss my-3">No pending posts to approve.</p>
                        )}
                      </div>
                    </div>

                    {/* Activity Logs Preview */}
                    <div className="col-lg-6 mb-4">
                      <div className="card shadow-xss border-0 p-4 rounded-xxl bg-white h-100">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h4 className="fw-700 font-xss text-grey-900 mb-0 d-flex align-items-center">
                            <i className="feather-activity text-primary me-2"></i> Recent Activity Logs
                          </h4>
                          <Link to="/admin/activity-logs" className="font-xssss fw-600 text-danger text-decoration-none">
                            View All &rarr;
                          </Link>
                        </div>
                        {stats?.recent_activities?.length > 0 ? (
                          <div className="table-responsive">
                            <table className="table table-borderless align-middle mb-0 font-xssss">
                              <tbody>
                                {stats.recent_activities.slice(0, 5).map((log) => (
                                  <tr key={log.id} className="border-bottom">
                                    <td className="py-2 ps-0" style={{ width: 35 }}>
                                      <i className="feather-check-circle text-success font-sm"></i>
                                    </td>
                                    <td>
                                      <p className="font-xssss text-grey-800 fw-500 mb-0">{log.description}</p>
                                    </td>
                                    <td className="text-end pe-0 text-grey-500 font-xsssss">
                                      {moment(log.created_at).fromNow()}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <p className="text-grey-500 font-xssss my-3">No activity logs recorded yet.</p>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
